module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/big/59-9f6a343d7d05cb62d8a3305aed03ad70.webp";